import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IGetInput,
    IGetResponse,
    IBuyerSupportChatMessagesClient,
} from 'interfaceAdapter/gatewaySchemas/IBuyerSupportChatMessagesClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');

export class BuyerSupportChatMessagesClient implements IBuyerSupportChatMessagesClient {
    async get(input: IGetInput): Promise<IGetResponse> {
        const { token } = input;

        const PATH = `${API_LOCATION_URL}/buyer/support_chat_messages`;
        const method = 'GET';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-B': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        try {
            const response = await fetch(PATH, {
                method,
                headers,
            });

            const { data, message } = await response.json();

            return {
                data,
                message,
            };
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}

